import { render } from "./BrokerageOverline.vue?vue&type=template&id=2756e076&ts=true"
import script from "./BrokerageOverline.vue?vue&type=script&lang=ts"
export * from "./BrokerageOverline.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../home/dory/Software/OrbiLog/docroot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__